import { HTTP_GET, HTTP_POST, HTTP_PUT, WebApiRequest } from "tools/webservice";
import employeeApi from "apis/employee";
import * as employeeRoles from "typeConstants/employeeRoles";

// move-to-map
export const moveToMap = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/move-to-map`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const getNextCase = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/next-case`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const sendCaseToUser = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/send-case-to-user`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const leaveCase = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/leave-case`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const getNextNotification = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/next-notification`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const getSchedulingManagers = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET, 
  endpoint: employeeApi.getEmployeesByRoles([employeeRoles.CUSTOMER_EXPERIENCE_MANAGER]),
  successCallback,
  mountedRef
  });

export const getSchedulingAssistants = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET, 
  endpoint: employeeApi.getEmployeesByRoles([employeeRoles.CUSTOMER_EXPERIENCE_REP, employeeRoles.CUSTOMER_EXPERIENCE_MANAGER]),
  successCallback,
  mountedRef
});

export const moveToTopOfSchedulingQueue = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/scheduling-assistant/cases/${controlIdNumber}/scheduling-queue/move-case-to-top`,
  successCallback,
  mountedRef,
});

export const moveToScheduling = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/scheduling-assistant/cases/move-to-scheduling`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
